import { useCallback, useState } from "react";
import { useAcknowledgementTemplate } from "../../../../hooks/services/useAcknowledgementTemplate";
import { AcknowledgementTemplateDto } from "../../../../services/generated/models/AcknowledgementTemplateDto";
import { IComboBoxOption } from "@fluentui/react";



export const useAcknowledgementTemplateService = () => {

  const {getUnitsTemplates} = useAcknowledgementTemplate();

  const [unitsTemplates, setUnitsTemplates] = useState<AcknowledgementTemplateDto[]>([]);
  const [options, setOptions] = useState<IComboBoxOption[]>([]);

      const refreshData = useCallback(async (unitId: number) =>  {
        const response = await getUnitsTemplates(unitId);
        
        if(!response || !response.result)
        {
          return;
        }
        setUnitsTemplates(response.result);
        const formattedOptions = response.result.map(item => ({
          key: item.id,  
          text: item.title || "",  
        }));
        const defaultOption = { key: -1, text: '' };
        setOptions([defaultOption, ...formattedOptions]);
      }, [getUnitsTemplates]);


  return {
    refreshData,
    options,
    unitsTemplates,
  };
};
